module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('v-toolbar', {
    staticClass: "accent",
    attrs: {
      "app": "",
      "fixed": "",
      "dark": ""
    }
  }, [(_vm.backDst) ? _c('v-toolbar-side-icon', {
    on: {
      "click": function($event) {
        _vm.back()
      }
    }
  }, [_c('v-icon', [_vm._v("arrow_back")])], 1) : (_vm.isStarted) ? _c('v-toolbar-side-icon', {
    on: {
      "click": function($event) {
        _vm.drawer = !_vm.drawer
      }
    }
  }) : _vm._e(), _c('v-toolbar-title', {
    staticClass: "header"
  }, [_vm._v("Secret Hitler")]), _c('v-spacer')], 1), _c('v-navigation-drawer', {
    staticClass: "pb-0",
    attrs: {
      "app": "",
      "temporary": ""
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-layout', {
    attrs: {
      "column": "",
      "fill-height": ""
    }
  }, [(_vm.isStarted) ? _c('v-layout', {
    staticClass: "scores",
    attrs: {
      "row": ""
    }
  }, [_c('v-layout', {
    staticClass: "score",
    attrs: {
      "column": "",
      "my-3": "",
      "ml-3": ""
    }
  }, [_c('policy-card', {
    attrs: {
      "policy": "LIBERAL"
    }
  }), _c('span', {
    staticClass: "title pa-3"
  }, [_vm._v(_vm._s(_vm.game.boardState.liberals))])], 1), _c('v-layout', {
    staticClass: "score",
    attrs: {
      "column": "",
      "ma-3": ""
    }
  }, [_c('policy-card', {
    attrs: {
      "policy": "FASCIST"
    }
  }), _c('span', {
    staticClass: "title pa-3"
  }, [_vm._v(_vm._s(_vm.game.boardState.fascists))])], 1)], 1) : _vm._e(), (_vm.isStarted) ? _c('v-layout', {
    staticClass: "election-tracker pb-2"
  }, [_vm._l((3), function(n) {
    return _c('v-layout', {
      key: n,
      attrs: {
        "align-center": "",
        "justify-center": ""
      }
    }, [(_vm.game.boardState.voteFailures == n - 1) ? _c('v-icon', [_vm._v("radio_button_checked")]) : _c('v-icon', [_vm._v("radio_button_unchecked")])], 1)
  }), _c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-icon', [_vm._v("error_outline")])], 1)], 2) : _vm._e(), _c('v-list', [_c('v-divider'), _vm._l((_vm.navs), function(arg) {
    return _c('v-list-tile', {
      key: arg.path,
      attrs: {
        "to": (arg.path)
      }
    }, [_c('v-list-tile-action', [_c('v-icon', {
      domProps: {
        "textContent": _vm._s(arg.icon)
      }
    })], 1), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(arg.label))])], 1)], 1)
  }), (_vm.game) ? _c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', [_vm._v("videogame_asset")])], 1), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Game code: " + _vm._s(_vm.game.name))])], 1)], 1) : _vm._e()], 2)], 1)], 1), _c('main', [_c('v-content', {
    staticClass: "content"
  }, [_c('router-view')], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0052d98a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src.player/ui/App.vue
// module id = 308
// module chunks = 0